module.exports = __webpack_public_path__ + "static/media/6.df29ab95.png";